export default {
    // Status
    open: 'Open',
    closed: 'Closed',
    groomedStatusCurrently: 'Grooming',
    groomedStatusPassed: 'Groomed ({{hoursPassed}} h)',
    groomedStatusYesterday: 'Groomed yesterday',
    groomedStatusWeekday: 'Groomed {{weekday}}',
    // Zone
    low: 'Low zone',
    high: 'High zone',
    // Difficulty
    veryEasy: 'Very easy',
    veryEasyPlural: 'Very easy',
    easy: 'Easy',
    easyPlural: 'Easy',
    medium: 'Medium',
    mediumPlural: 'Medium',
    hard: 'Hard',
    hardPlural: 'Hard',
    // Abbreviated weekdays
    abbreviatedMonday: 'mon',
    abbreviatedTuesday: 'tue',
    abbreviatedWednesday: 'wed',
    abbreviatedThursday: 'thu',
    abbreviatedFriday: 'fri',
    abbreviatedSaturday: 'sat',
    abbreviatedSunday: 'sun',
    // Measurements
    elevationAboveSeaLevel: 'm.a.s.l.',
    // Misc
    switchDirection: 'Switch direction',
    destinationNamePlaceholder: 'Destination name here',
    mapTypeMap: 'Map',
    mapTypeSatelite: 'Satellite',
    mapTypeThreeD: '3D',
    mapTypeThreeDSatelite: '3D Satellite',
    mapChooserTitle: 'Choose map',
    mapChooserStandard: 'Standard',
    mapChooserThreeDStandard: '3D Std.',
    mapChooserThreeDSatellite: '3D Sat.',
    mapChooserSettingsTitle: 'Settings',
    mapChooserDirection: 'Direction',
    mapChooserOpen: 'Map',
    mapChooserClose: 'Close',
    mapFilterTitle: 'Filter',
    mapFilterPathTypes: 'Trail types',
    mapFilterPoiTypes: 'POI types',
    mapFilterOpen: 'Filter',
    mapFilterClose: 'Close',
    mapFilterReset: 'Reset',
    compositeChildrenDropdownLabel: 'Subpaths',
    compositeChildLabel: 'Section',
    compositeChildCount_one: '{{count}} section',
    compositeChildCount_other: '{{count}} sections',
    expandCompositeTrail: 'Show sections',
    collapseCompositeTrail: 'Hide sections',
    compositeParentLink: 'Go to composite trail: {{name}}',
    selectTrail: 'Select trail',
};